import { gql } from '__generated__';

export default gql(`
  query GetContactFilters($project_id: ID!, $events: [ID!]!) {
    project(id: $project_id) {
      id
      events(ids: $events) {
        data {
          id
          title
          allow_teams
        }
      }
      mail_permissions {
        id
        title
        interest_list_event {
          id
        }
        events {
          id
        }
      }
      messages {
        data {
          id
          title
        }
      }
    }
  }
`);
